import { render, staticRenderFns } from "./userVoicevercode.vue?vue&type=template&id=f7186f0a"
import script from "./userVoicevercode.vue?vue&type=script&lang=js"
export * from "./userVoicevercode.vue?vue&type=script&lang=js"
import style0 from "./userVoicevercode.vue?vue&type=style&index=0&id=f7186f0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserHeader: require('/root/workspace/web-company_Yo6Q/components/userLogin/userHeader.vue').default})
